export { default } from 'ember-collapsible-panel/services/panel-actions';
